// extracted by mini-css-extract-plugin
module.exports = {"FooterList":"FooterList_FooterList__3j_Sk","Title":"FooterList_Title__t5l8F","Items":"FooterList_Items__O9ddU","ListItem":"FooterList_ListItem__zk9Lg"};